import {axiosInstance, axiosInstanceGraphQL} from '../../axios/axios'

export const fetchRoles = async (token) => {
    const response = await axiosInstance.get('/api/roles', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

export const syncUserPermissions = async (token, userId, permissions) => {
  const response = await axiosInstance.post(
    `/api/users/${userId}/permissions/sync`,
    { permissions },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}


export const getPermissionsApi = async (token, userId) =>
    await axiosInstance.get(`/api/users/${userId}/permissions`, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then((response) => response)
      .catch((error) => error.response)

export const getContactRequest = async (token, query) =>
    await axiosInstanceGraphQL.post('/graphql', {
        query: query
    }, {
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })

export const getContactRequestApi = async (token, query) =>
    await axiosInstance.get(`api/contact_by_id/1`, {
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })

export const updateContactRequest = async (token, query) =>
    await axiosInstanceGraphQL.post('/graphql', {
        query: query
    }, {
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response
        })

export const updateContactPhoneRequest = async (token,values) =>
    await axiosInstance.put('/api/auth/user',values, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
                .then(function (response) {
                    return response
                })
                .catch(function (error) {
                    return error.response
                })


export const deleteContactRequest = async (token, query) =>
    await axiosInstanceGraphQL .post( "/graphql", {
        query: query,
    }, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const sendInvitationRequest = async (token, id) =>
    await axiosInstanceGraphQL .post( "/api/contact/send_invitation", {
        id: id,
    }, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const updateCompanyInvoiceRequest = async (token, data) =>
    await axiosInstanceGraphQL.post( "/api/company/invoice", data, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });

export const getCompanyInvoiceAllRequest = async (token) =>
    await axiosInstanceGraphQL.get( "/api/company/invoices/all", {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });

export const updateCompanyInvoiceSingleRequest = async (token, id) =>
    await axiosInstanceGraphQL.get( "/api/company/invoice/" + id, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const updateCompanyInvoiceTicketRequest = async (token, form) =>
    await axiosInstanceGraphQL.post( "/api/company/invoice_ticket", form, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const updateCompanyInvoiceValidateRequest = async (token, id) =>
    await axiosInstanceGraphQL.get( "/api/company/invoice_validate/" + id, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const updateCompanyInvoiceValidateItemRequest = async (token, form) =>
    await axiosInstanceGraphQL.post( "/api/company/invoice/item/validate", form, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });


export const getCompaniesListRecruiterRequest = async (token) =>
    await axiosInstance.get( "/api/company/recruiter", {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
    .then(function (response) {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });


export const getCompanyTeamRequest = async (token) =>
    await axiosInstance.get( "/api/company/team", {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
    .then(function (response) {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });


export const getCompanyTalentTimesheetRequest = async (token, id, invoice_id) =>
    await axiosInstance.get( "/api/company/talent/timesheet/" + id + "/" + invoice_id, {
        headers: {
            Authorization: "Bearer " + token,
        },
    })
    .then(function (response) {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });